import styled from "styled-components";

import { NormalizedList } from "@ui/Atoms/List";

export const Root = styled.div`
  position: relative;
  display: grid;
`;

export const MobileButton = styled.button`
  all: unset;

  position: absolute;
  inset: 0;
  z-index: 3;
  cursor: pointer;

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: none;
  }
`;

export const DrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.spacing_24};
`;

export const DrawerList = styled(NormalizedList)`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.spacing_24};
`;
